import { differenceInDays } from 'date-fns';

import { MODAL_CADENCE_IN_DAYS, MODAL_SHOWN_TIMES_LIMIT } from './missingBillingAddress.consts';

export function shouldShowBillingModal(isManager: boolean, modalClosedCount = 0, lastShown: Date) {
  return (
    isManager &&
    modalClosedCount < MODAL_SHOWN_TIMES_LIMIT &&
    (!lastShown || differenceInDays(new Date(), lastShown) >= MODAL_CADENCE_IN_DAYS)
  );
}
